module.exports = __webpack_public_path__ + "img/CCLeumi45.f420d78c.png";